import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import DirectoryAuthMenu from "../../Auth/DirectoryAuthMenu.jsx";
import { useAuth } from "../../../../context/AuthContext";
import api from "@api";
import "./DirectoryNavbar.css";

function DirectoryNavbar() {
    const { user } = useAuth();
    const [profileId, setProfileId] = useState(null);

    useEffect(() => {
        const fetchMyProfile = async () => {
            if (!user) {
                setProfileId(null);
                return;
            }

            try {
                const res = await api.get("/api/user-profiles-v2/me", {
                    withCredentials: true,
                });

                setProfileId(res.data.profile?.id || null);
            } catch (error) {
                console.error("Failed to fetch profile:", error);
                setProfileId(null);
            }
        };

        fetchMyProfile();
    }, [user]);

    return (
        <div className="directory-top-bar">
            <div className="directory-top-left">
                <NavLink to="/" className="directory-brand-block">
                    <div className="directory-main-logo">
                        <span className="directory-logo-sporting">Sporting</span>
                        <span className="directory-logo-hip">Hip</span>
                    </div>

                    <div className="directory-intro">
                        Sports made easy to find
                    </div>
                </NavLink>
            </div>

            <nav className="directory-navbar-links">
                <NavLink
                    to="/wall"
                    className={({ isActive }) =>
                        `directory-navbar-link ${isActive ? "active" : ""}`
                    }
                >
                    Wall
                </NavLink>

                <NavLink
                    to="/"
                    end
                    className={({ isActive }) =>
                        `directory-navbar-link ${isActive ? "active" : ""}`
                    }
                >
                    Find Sports
                </NavLink>

                <NavLink
                    to="/field"
                    className={({ isActive }) =>
                        `directory-navbar-link ${isActive ? "active" : ""}`
                    }
                >
                    The Arena
                </NavLink>

                {user && profileId && (
                    <NavLink
                        to={`/profile/${profileId}`}
                        end
                        className={({ isActive }) =>
                            `directory-navbar-link ${isActive ? "active" : ""}`
                        }
                    >
                        My Profile
                    </NavLink>
                )}
            </nav>

            <div className="directory-auth-actions">
                <DirectoryAuthMenu />
            </div>
        </div>
    );
}

export default DirectoryNavbar;